import React from "react";
import BaseMenuPrincipal from "../../../componentes/BaseMenuPrincipalComponent/BaseMenuPrincipal";
import { InfoLateralSaida } from "../../../componentes/InfoLateralSaidaComponents/InfoLateralSaidaComponents";

const Saidas = () => {
    return(
        <>
            <BaseMenuPrincipal 
            
            InfoLateral={<InfoLateralSaida />}/>
        </>
    )
}

export default Saidas;